import { InstitutionType } from '@do/models';

import { NavigationLink } from '@features/navigation/libs';

export const mainUFDASitemap = [
  NavigationLink.Main,
  NavigationLink.Auctions,
  NavigationLink.Artworks,
  NavigationLink.Selections,
  NavigationLink.Artists,
  NavigationLink.Curators,
  NavigationLink.AboutUsUFDA,
  NavigationLink.Process,
  NavigationLink.Contacts,
  NavigationLink.FAQ,
] as const;

export const mainInstitutionSitemaps = {
  [InstitutionType.Artist]: [
    NavigationLink.Main,
    NavigationLink.Auctions,
    NavigationLink.Artworks,
    NavigationLink.Selections,
    NavigationLink.Biography,
    NavigationLink.FAQ,
    NavigationLink.Contacts,
  ],
  [InstitutionType.Photographer]: [
    NavigationLink.Main,
    NavigationLink.Auctions,
    NavigationLink.Artworks,
    NavigationLink.Selections,
    NavigationLink.Biography,
    NavigationLink.FAQ,
    NavigationLink.Contacts,
  ],
  [InstitutionType.Curator]: [
    NavigationLink.Main,
    NavigationLink.Auctions,
    NavigationLink.Artworks,
    NavigationLink.Selections,
    NavigationLink.Artists,
    NavigationLink.Biography,
    NavigationLink.FAQ,
    NavigationLink.Contacts,
  ],
  [InstitutionType.Collector]: [
    NavigationLink.Main,
    NavigationLink.Auctions,
    NavigationLink.Artworks,
    NavigationLink.Artists,
    NavigationLink.Biography,
    NavigationLink.FAQ,
    NavigationLink.Contacts,
  ],
  [InstitutionType.Gallery]: [
    NavigationLink.Main,
    NavigationLink.Auctions,
    NavigationLink.Artworks,
    NavigationLink.Selections,
    NavigationLink.Artists,
    NavigationLink.Curators,
    NavigationLink.About,
    NavigationLink.FAQ,
    NavigationLink.Contacts,
  ],
  [InstitutionType.Agency]: [
    NavigationLink.Main,
    NavigationLink.Auctions,
    NavigationLink.Artworks,
    NavigationLink.Selections,
    NavigationLink.Artists,
    NavigationLink.Curators,
    NavigationLink.About,
    NavigationLink.FAQ,
    NavigationLink.Contacts,
  ],
} as const satisfies { [key in InstitutionType]: readonly NavigationLink[] };
